<ul id="js-schema-tabs" class="nav nav-tabs scheme-tabs">
	{{#each tabs}}
	<li {{#if active}}class="active"{{/if}}>
		<a id="{{@index}}" href="#{{@index}}" class="js-schema-tab" data-toggle="tab" aria-expanded="false">
			<span>{{name}}</span>{{#if warning}}<i class="fa fa-circle error p-l-5"></i>{{/if}}
		</a>
	</li>
	{{/each}}
</ul>
